<div class="details-container p-10">
  <div class="details-wrapper flex flex-col">
    <div class="flex flex-col">
      <h4 class="product-heading-bold flex-row">Update your {{ 'scope|l' | lang }} details</h4>

      <mat-divider></mat-divider>

      <div class="flex-row pt-8">
        <scope-ui-input
          [inputLabel]="('scope' | lang) + ' name'"
          [initialValue]="currentScope.name"
          [required]="true"
          [isDisabled]="!currentScope.isDraftOrConfigDraft()"
          (onInputChange)="updateScopeRequest.name = $event" />
        <p>
          The name of your {{ 'scope|l' | lang }} is the name you would usually give a {{ 'scope|l' | lang }} of work -
          it describes the set of campaign {{ 'deliverable.p|l' | lang }} you&#39;re preparing a cost for.
        </p>
      </div>

      <div
        class="flex-row pt-8"
        [has-privilege]="Privilege.OFFICE_LOCATION__VIEW">
        <scope-ui-autocomplete
          placeholder="Choose office location"
          noResultsMessage="No office locations found"
          [options]="officeLocations!"
          [optionFn]="getOfficeLocationDisplayName"
          [initialValue]="updateScopeRequest.identity.officeLocation"
          (onSelectionChange)="selectOfficeLocation($event.event)" />
        <p>
          Select an office location. This will determine the available {{ 'second_party.p|l' | lang }} and
          {{ 'brand.p|l' | lang }}.
        </p>
      </div>

      <div class="flex-row pt-8">
        <scope-ui-autocomplete
          [options]="getSecondParties()"
          [initialValue]="updateScopeRequest.identity.secondParty"
          [placeholder]="'Choose one ' + ('second_party|l' | lang)"
          [disabled]="!currentScope.isDraftOrConfigDraft()"
          [noResultsMessage]="'No ' + ('second_party.p|l' | lang) + ' found'"
          (onSelectionChange)="onSelectSecondParty($event.event)" />
        <p>
          Select from {{ 'second_party.p|l' | lang }} which can provide specific details of key contacts and locations.
        </p>
        <p>
          Please note, the rate-card of the {{ 'scope|l' | lang }} will remain unaffected and this
          {{ 'scope|l' | lang }} is using '{{ currentScope.identity.rateCard.name }}' rate-card.
        </p>
      </div>

      <div
        *ngIf="!currentScope.isScopeByRole()"
        class="flex-row pt-8">
        <scope-ui-autocomplete
          [options]="selectedSecondParty?.brands || []"
          [initialValue]="updateScopeRequest.identity.brand"
          [placeholder]="'Choose ' + ('brand|l' | lang)"
          [disabled]="!(selectedSecondParty && selectedSecondParty.brands?.length)"
          [noResultsMessage]="'No ' + ('brand.p|l' | lang) + ' found'"
          (onSelectionChange)="onSelectBrand($event.event)" />

        <p *ngIf="!selectedSecondParty">
          {{ 'brand.p' | lang }} within {{ 'second_party.p|l' | lang }} can be selected once a
          {{ 'second_party|l' | lang }} has been selected.
        </p>
        <p *ngIf="selectedSecondParty?.brands?.length == 0">
          Your selected {{ 'second_party|l' | lang }} does not contain any {{ 'brand.p|l' | lang }}.
        </p>
        <p *ngIf="selectedSecondParty?.brands?.length">
          Optionally select from a {{ 'brand|l' | lang }} which can provide specific details of key contacts, locations
          and ratecard
        </p>
      </div>

      <div class="flex-row pt-8">
        <scope-ui-autocomplete
          placeholder="Choose a key contact"
          noResultsMessage="No key contacts found"
          [options]="getContacts()"
          [optionFn]="getContactDisplayName"
          [displayFn]="getContactDisplayName"
          [initialValue]="updateScopeRequest.identity.contact"
          [disabled]="!currentScope.isDraftOrConfigDraft()"
          (onSelectionChange)="onSelectKeyContact($event.event)" />
        <p *ngIf="!selectedSecondParty">
          Key contacts within {{ 'second_party.p|l' | lang }} can be selected once a {{ 'second_party|l' | lang }} has
          been selected.
        </p>
        <p *ngIf="selectedSecondParty && !selectedBrand">
          All key contacts come from the contact list in {{ 'second_party' | lang }} card. If you&#39;re an admin
          member, you can set these up in the {{ 'second_party' | lang }} section
        </p>
        <p *ngIf="selectedSecondParty && selectedBrand">
          All key contacts come from the {{ 'brand|l' | lang }} location in {{ 'second_party' | lang }} card. If
          you&#39;re an admin member, you can set these up in the {{ 'second_party' | lang }} section
        </p>
      </div>

      <div class="flex-row pt-8">
        <scope-ui-autocomplete
          placeholder="Choose a location"
          noResultsMessage="No locations found"
          [options]="getLocations()"
          [optionFn]="getLocationDisplayName"
          [displayFn]="getLocationSimpleName"
          [initialValue]="updateScopeRequest.identity.location"
          [disabled]="!currentScope.isDraftOrConfigDraft() || selectedBrand != null"
          (onSelectionChange)="onSelectLocation($event.event)" />
        <p *ngIf="!updateScopeRequest.identity.location">
          All {{ 'second_party' | lang }} locations come from the location list in {{ 'second_party' | lang }} card. If
          you&#39;re an admin member, you can set these up in the Client section
        </p>
        <ng-container *ngIf="updateScopeRequest.identity.location">
          <p *ngIf="getLocationByISO(updateScopeRequest.identity.location.country) as country">
            <span *ngIf="selectedBrand">Provided by {{ 'brand|l' | lang }}. </span>
            <span>
              <b>{{ updateScopeRequest.identity.location.location }}: </b>
              <span>
                {{ updateScopeRequest.identity.location.getAddress() }} ({{ country?.Country_Name }},
                {{ country?.Continent }})
              </span>
            </span>
          </p>
        </ng-container>
      </div>

      <div class="flex-row pt-8">
        <scope-ui-autocomplete
          [options]="xlsxTemplates!"
          [initialValue]="updateScopeRequest.identity.xlsxTemplate"
          [placeholder]="'Choose an ' + ('output|l' | lang) + ' excel template'"
          noResultsMessage="No templates found"
          (onSelectionChange)="onSelectTemplate($event.event)" />
        <p>
          All excel {{ 'doc_template.p|l' | lang }} come from the template list in {{ 'doc_template' | lang }} card. If
          you&#39;re an admin member, you can set these up in the {{ 'doc_template' | lang }} section
        </p>
      </div>

      <ng-container
        *ngIf="
          selectedSecondParty &&
          selectedSecondParty.trafficImported &&
          currentScope.identity.rateCard.rateCardIdentity.trafficImported &&
          !currentScope.isScopeByRole()
        ">
        <div
          *ngFor="let field of trafficMetadataLookupFields"
          class="flex-row pt-8">
          <ng-container *ngIf="field.url; else noUrlField">
            <scope-ui-autocomplete
              [placeholder]="field.name"
              [options]="(trafficSystemMetadataSearch$[field.uuid] | async)!"
              [optionFn]="getTrafficFieldOption"
              [initialValue]="updateScopeRequest.trafficSystemEntityMetadata[field.uuid]"
              [filterByAction]="true"
              (onSearch)="
                onSearchTrafficField(
                  $event.searchString,
                  selectedSecondParty.id,
                  currentScope.identity.rateCard.rateCardIdentity.id,
                  field.uuid
                )
              "
              (onSelectionChange)="selectTrafficField($event.event, field.uuid)" />
          </ng-container>

          <ng-template #noUrlField>
            <textarea
              matInput
              required
              type="text"
              maxlength="122"
              class="resize-none"
              placeholder="{{ field.name }}"
              [(ngModel)]="trafficMetaDataFieldTemp[field.uuid]"
              (change)="updateTrafficSystemMetadataField(field.uuid)"></textarea>
          </ng-template>

          <p>{{ field.description }}</p>
        </div>
      </ng-container>

      <div
        *ngIf="!currentScope.isScopeByRole()"
        class="flex-row pt-8"
        [has-setting]="ApplicationSetting.SCOPE__BENCHMARK_RATE_CARD">
        <scope-ui-autocomplete
          placeholder="Select Benchmark Rate Card"
          noResultsMessage="No rate cards found"
          [options]="benchmarkRateCards!"
          [initialValue]="updateScopeRequest.identity.benchmarkRateCard"
          [disabled]="!selectedSecondParty"
          (onSelectionChange)="onSelectBenchmarkRateCard($event.event)" />
      </div>

      <div
        class="flex flex-row pt-8"
        style="width: 500px"
        [has-setting]="ApplicationSetting.SCOPE__START_END_DATE">
        <scope-ui-datepicker
          class="flex flex-col flex-1 mr-4"
          inputLabel="Start Date"
          validationError="Some {{ 'deliverable.p|l' | lang }} have the dates outside of this range"
          [singleDatePicker]="true"
          [disabled]="!currentScope.isDraftOrConfigDraft()"
          [initialValue]="updateScopeRequest.startDate"
          [maxDate]="maximumStartDate"
          (onSelect)="updateScopeRequest.startDate = $event">
        </scope-ui-datepicker>
        <scope-ui-datepicker
          class="flex flex-col flex-1 ml-4"
          inputLabel="End Date"
          validationError="Some {{ 'deliverable.p|l' | lang }} have the dates outside of this range"
          [singleDatePicker]="true"
          [disabled]="!currentScope.isDraftOrConfigDraft()"
          [initialValue]="updateScopeRequest.endDate"
          [minDate]="getMinEndDate()"
          (onSelect)="updateScopeRequest.endDate = $event">
        </scope-ui-datepicker>
      </div>

      <div class="flex-row pt-8">
        <scope-ui-input
          [inputLabel]="getBudgetLabel()"
          [initialValue]="updateScopeRequest.budget?.amount | number: '1.2-2'"
          [required]="true"
          [minimum]="0"
          [type]="'text'"
          [parseNumber]="true"
          [isCurrency]="true"
          [currency]="currencyCode"
          [isDisabled]="!currentScope.isDraftOrConfigDraft()"
          (onInputBlurChange)="updateBudget($event)"
          aria-label="Budget" />
        <p>An estimated budget of the {{ 'scope' | lang }}</p>
      </div>

      <div class="flex-row pt-8">
        <scope-ui-input
          [inputLabel]="getTPCBudgetLabel()"
          [initialValue]="updateScopeRequest.thirdPartyCostBudget?.amount | number: '1.2-2'"
          [required]="true"
          [minimum]="0"
          [type]="'text'"
          [parseNumber]="true"
          [isCurrency]="true"
          [currency]="currencyCode"
          [isDisabled]="!currentScope.isDraftOrConfigDraft()"
          (onInputBlurChange)="updateTPCBudget($event)"
          aria-label="Budget" />
        <p>An estimated budget of the {{ 'scope' | lang }} third party cost</p>
      </div>

      <ng-container
        *ngIf="
          !currentScope.isScopeByRole() &&
          (customFieldValueStructure?.fieldValues?.length || customFieldsDefinitionOutdated)
        ">
        <div
          class="flex flex-row justify-between pt-8"
          style="width: 500px">
          <p>Specific fields of the company</p>
          <button
            *ngIf="customFieldsDefinitionOutdated"
            mat-mini-fab
            [matMenuTriggerFor]="menu">
            <mat-icon class="material-symbols-rounded">more_horiz</mat-icon>
          </button>
        </div>
        <mat-menu
          #menu="matMenu"
          backdropClass="customize">
          <button
            (click)="confirmMetaStructureUpdate()"
            mat-menu-item
            class="scope-option">
            <mat-icon class="material-symbols-rounded orange">warning</mat-icon>
            <span>Update custom fields</span>
          </button>
        </mat-menu>
        <div
          class="flex-row pt-8"
          *ngFor="let customField of customFieldValueStructure?.fieldValues | orderBy: 'order'">
          <label class="text-xs font-newJuneBold field-label">
            {{ currentScope.companyScopeCustomFieldsDefinition.getName(customField.id) }}
          </label>
          <scope-ui-input
            class="custom-field"
            [initialValue]="customField.value"
            (onInputChange)="customField.value = $event" />
        </div>
      </ng-container>

      <ng-container
        *ngIf="scopeDynamicFieldSettings?.length > 0"
        [has-setting]="ApplicationSetting.SCOPE_DYNAMIC_FIELDS">
        <div class="font-bold text-sm mt-4">Scope Dynamic Fields</div>
        <div class="flex flex-col flex-wrap gap-5">
          <scope-ui-input
            *ngFor="let setting of scopeDynamicFieldTextSettings"
            class="flex-row"
            [class.locked-field]="setting.locked"
            [initialValue]="getTextDynamicFieldValue(setting)"
            [inputLabel]="setting.displayName!"
            [required]="setting.mandatory"
            [isDisabled]="setting.locked"
            [isTextarea]="true"
            [textareaRows]="1"
            [autoExpand]="true"
            (onInputChange)="onInputDynamicFieldTextSettingChange(setting, $event)" />
          <scope-ui-autocomplete
            class="flex-1"
            *ngFor="let settingWithOptions of scopeDynamicFieldDropdownSettingsWithOptions"
            [class.locked-field]="settingWithOptions.setting.locked"
            [label]="settingWithOptions.setting.displayName"
            [options]="settingWithOptions.options"
            [initialValue]="getDropdownDynamicFieldValue(settingWithOptions)"
            [required]="settingWithOptions.setting.mandatory"
            [disabled]="settingWithOptions.setting.locked"
            (onSelectionChange)="onSelectDropdownDynamicField($event, settingWithOptions.setting.name)" />
          <scope-ui-autocomplete
            *ngFor="let externalSettingWithOptions of scopeDynamicFieldDropdownExternalSettingsWithOptions"
            class="flex-row"
            [class.locked-field]="externalSettingWithOptions.setting.locked"
            orderBy="name"
            [label]="externalSettingWithOptions.setting.displayName"
            [options]="externalSettingWithOptions.options"
            [initialValue]="getExternalDropdownDynamicFieldValue(externalSettingWithOptions)"
            [disabled]="externalSettingWithOptions.setting.locked"
            (onSelectionChange)="onSelectDropdownExternalDynamicField($event, externalSettingWithOptions)" />
        </div>
      </ng-container>

      <div
        *ngIf="!currentScope.isScopeByRole() && currentScope.scopeOfWorkVersion && showUseRetainedTeamToggle"
        class="flex-row pt-8">
        <mat-checkbox
          aria-label="Use Retained Hours"
          value="{{ currentScope.useRetainedHours }}"
          [disabled]="!currentScope.isDraftOrConfigDraft()"
          [checked]="currentScope.useRetainedHours"
          (change)="updateUseRetainedHours($event.checked)">
          Use Retained hours {{ isUseRetainedHours() ? ' (On)' : ' (Off)' }}
        </mat-checkbox>
      </div>

      <button
        mat-flat-button
        class="w-40 mt-10"
        [buttonSpinner]="isUpdateLoading"
        [disabled]="!isFormValidFlag"
        (click)="saveDetails()">
        Save Details
      </button>
    </div>
  </div>
</div>
